import { SortingHeaderButton } from '@/components/ui/DataTable/SortingHeaderButton'
import { RestSchemas } from '@/contexts/QueryProvider'
import { ColumnDef } from '@tanstack/react-table'
import { RowActionsMenu } from './RowActionsMenu'

type ApplicationSetting = RestSchemas['Messages.Applications.ApplicationSetting']

export const appSettingsTableColumns: ColumnDef<ApplicationSetting>[] = [
  {
    id: 'key',
    accessorKey: 'key',
    header: ({ column }) => <SortingHeaderButton column={column}>Setting key</SortingHeaderButton>,
    cell: ({ row }) => row.original.key ?? 'Not set',
    sortingFn: (rowA, rowB) => (rowA.original.key ?? '').localeCompare(rowB.original.key ?? ''),
  },
  {
    id: 'type',
    accessorKey: 'type',
    header: ({ column }) => <SortingHeaderButton column={column}>Setting type</SortingHeaderButton>,
    cell: ({ row }) => row.original.type ?? 'Not set',
    sortingFn: (rowA, rowB) => (rowA.original.type ?? '').localeCompare(rowB.original.type ?? ''),
  },
  {
    id: 'actions',
    cell: ({ row }) => (
      <div className="flex justify-end">
        <RowActionsMenu row={row.original} />
      </div>
    ),
  },
]
